var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.shouldDisplay
        ? _c("div", { class: _vm.$style.container }, [
            _c("div", { class: _vm.$style.content }, [
              _c(
                "div",
                { class: _vm.$style.icon },
                [_c("NsIcon", { attrs: { "icon-name": "icon-info" } })],
                1
              ),
              _vm._v(" "),
              _c("div", { class: _vm.$style.message }, [
                _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "NsModal",
        {
          attrs: { title: _vm.modalTitle, warning: "", confirm: "" },
          scopedSlots: _vm._u([
            {
              key: "actions",
              fn: function(ref) {
                var close = ref.close
                return [
                  _c(
                    "v-layout",
                    { attrs: { "justify-end": "" } },
                    [
                      _c(
                        "NsButton",
                        {
                          staticClass: "primary-solid fluid",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              ;[close(), _vm.handleModalClose()]
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.modalButtonText) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.shouldShowModal,
            callback: function($$v) {
              _vm.shouldShowModal = $$v
            },
            expression: "shouldShowModal"
          }
        },
        [_c("span", [_vm._v(_vm._s(_vm.modalMessage))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }